/**
 * Deploy-specific configuration constants.
 */

export const IFRAME_EMBED_ALLOWED_LOCATIONS = [];
